class DFFNotesService {
  static setNotes = async (api, configuration, notes) => {
    api.onFieldNotesChange(configuration.section, configuration.id, notes)
  };
}

export default DFFNotesService;